/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_Step_CollapseInputs */

const en_admin_ai_chat_step_collapse = /** @type {(inputs: Admin_Ai_Chat_Step_CollapseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collapse reasoning`)
};

const de_admin_ai_chat_step_collapse = /** @type {(inputs: Admin_Ai_Chat_Step_CollapseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begründung einklappen`)
};

const es_admin_ai_chat_step_collapse = /** @type {(inputs: Admin_Ai_Chat_Step_CollapseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar razonamiento`)
};

const fr_admin_ai_chat_step_collapse = /** @type {(inputs: Admin_Ai_Chat_Step_CollapseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réduire le raisonnement`)
};

const nl_admin_ai_chat_step_collapse = /** @type {(inputs: Admin_Ai_Chat_Step_CollapseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redenering samenvouwen`)
};

/** @type {(inputs: Admin_Ai_Chat_Step_CollapseInputs) => LocalizedString} */
const it_admin_ai_chat_step_collapse = en_admin_ai_chat_step_collapse;

/** @type {(inputs: Admin_Ai_Chat_Step_CollapseInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_step_collapse = en_admin_ai_chat_step_collapse;

/** @type {(inputs: Admin_Ai_Chat_Step_CollapseInputs) => LocalizedString} */
const pl_admin_ai_chat_step_collapse = en_admin_ai_chat_step_collapse;

/** @type {(inputs: Admin_Ai_Chat_Step_CollapseInputs) => LocalizedString} */
const hu_admin_ai_chat_step_collapse = en_admin_ai_chat_step_collapse;

/** @type {(inputs: Admin_Ai_Chat_Step_CollapseInputs) => LocalizedString} */
const ro_admin_ai_chat_step_collapse = en_admin_ai_chat_step_collapse;

/**
* | output |
* | --- |
* | "Collapse reasoning" |
*
* @param {Admin_Ai_Chat_Step_CollapseInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_step_collapse = /** @type {((inputs?: Admin_Ai_Chat_Step_CollapseInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Step_CollapseInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_step_collapse(inputs)
	if (locale === "de") return de_admin_ai_chat_step_collapse(inputs)
	if (locale === "es") return es_admin_ai_chat_step_collapse(inputs)
	if (locale === "fr") return fr_admin_ai_chat_step_collapse(inputs)
	if (locale === "nl") return nl_admin_ai_chat_step_collapse(inputs)
	if (locale === "it") return it_admin_ai_chat_step_collapse(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_step_collapse(inputs)
	if (locale === "pl") return pl_admin_ai_chat_step_collapse(inputs)
	if (locale === "hu") return hu_admin_ai_chat_step_collapse(inputs)
	return ro_admin_ai_chat_step_collapse(inputs)
});
export { admin_ai_chat_step_collapse as "admin.ai_chat.step_collapse" }